export default __webpack_public_path__ + "static/media/reply.570773ef.svg";